"use strict";
var AludarisCalcEngine = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // src/index.ts
  var index_exports = {};
  __export(index_exports, {
    DEFAULT_COOLING_SHRINKAGE_PCT: () => DEFAULT_COOLING_SHRINKAGE_PCT,
    DEFAULT_GRAIN_ABSORPTION_L_PER_KG: () => DEFAULT_GRAIN_ABSORPTION_L_PER_KG,
    GRAIN_WATER_HEAT_CAPACITY_RATIO: () => GRAIN_WATER_HEAT_CAPACITY_RATIO,
    calculateABV: () => calculateABV,
    calculateABVAdvanced: () => calculateABVAdvanced,
    calculateIbu: () => calculateIbu,
    calculateIbuRager: () => calculateIbuRager,
    calculateIbuTinseth: () => calculateIbuTinseth,
    calculateMCU: () => calculateMCU,
    calculateMashInfusionVolume: () => calculateMashInfusionVolume,
    calculateOG: () => calculateOG,
    calculateSRM: () => calculateSRM,
    calculateStrikeWaterTemp: () => calculateStrikeWaterTemp,
    calculateTotalWaterNeeded: () => calculateTotalWaterNeeded,
    ebcToSrm: () => ebcToSrm,
    estimateFG: () => estimateFG,
    exportBeerXml: () => exportBeerXml,
    importBeerXml: () => importBeerXml,
    potentialSgToYieldPct: () => potentialSgToYieldPct,
    scaleRecipe: () => scaleRecipe,
    srmToEbc: () => srmToEbc,
    yieldPctToPotentialSg: () => yieldPctToPotentialSg
  });

  // src/gravity.ts
  var PPG_TO_METRIC_FACTOR = 8.3454;
  function calculateOG(input) {
    const { fermentables, batchVolumeL, efficiencyPct } = input;
    if (batchVolumeL <= 0) {
      throw new Error("batchVolumeL turi b\u016Bti teigiamas skai\u010Dius");
    }
    const efficiency = efficiencyPct / 100;
    const totalPoints = fermentables.reduce((sum, f) => {
      const potentialPoints = (f.potentialSg - 1) * 1e3;
      return sum + f.weightKg * potentialPoints * efficiency * PPG_TO_METRIC_FACTOR / batchVolumeL;
    }, 0);
    return 1 + totalPoints / 1e3;
  }
  function estimateFG(og, attenuationPct) {
    const attenuation = attenuationPct / 100;
    return 1 + (og - 1) * (1 - attenuation);
  }
  function calculateABV(og, fg) {
    return (og - fg) * 131.25;
  }
  function calculateABVAdvanced(og, fg) {
    return 76.08 * (og - fg) / (1.775 - og) * (fg / 0.794);
  }

  // src/ibu.ts
  var HOP_FORM_FACTOR = {
    pellet: 1,
    leaf: 0.9
  };
  function hopFormFactor(form) {
    return HOP_FORM_FACTOR[form != null ? form : "pellet"];
  }
  function mgPerLiterAlphaAcid(hop, batchVolumeL) {
    const alphaDecimal = hop.alphaAcidPct / 100;
    return hop.weightG * alphaDecimal * 1e3 * hopFormFactor(hop.form) / batchVolumeL;
  }
  function tinsethUtilization(boilTimeMin, boilGravity) {
    const bignessFactor = 1.65 * Math.pow(125e-6, boilGravity - 1);
    const timeFactor = (1 - Math.exp(-0.04 * boilTimeMin)) / 4.15;
    return bignessFactor * timeFactor;
  }
  function calculateIbuTinseth(input) {
    const { hops, batchVolumeL, boilGravity } = input;
    return hops.reduce((total, hop) => {
      const utilization = tinsethUtilization(hop.boilTimeMin, boilGravity);
      return total + utilization * mgPerLiterAlphaAcid(hop, batchVolumeL);
    }, 0);
  }
  function ragerUtilizationPct(boilTimeMin, boilGravity) {
    const base = 18.11 + 13.86 * Math.tanh((boilTimeMin - 31.32) / 18.27);
    if (boilGravity > 1.05) {
      const gravityAdjustment = (boilGravity - 1.05) / 0.2;
      return base / (1 + gravityAdjustment);
    }
    return base;
  }
  function calculateIbuRager(input) {
    const { hops, batchVolumeL, boilGravity } = input;
    return hops.reduce((total, hop) => {
      const utilization = ragerUtilizationPct(hop.boilTimeMin, boilGravity) / 100;
      return total + utilization * mgPerLiterAlphaAcid(hop, batchVolumeL);
    }, 0);
  }

  // src/color.ts
  function calculateMCU(input) {
    const { fermentables, batchVolumeL } = input;
    const volumeGal = batchVolumeL / 3.785;
    const totalLbDegL = fermentables.reduce((sum, f) => {
      var _a;
      const colorL = (_a = f.colorLovibond) != null ? _a : 0;
      const weightLb = f.weightKg * 2.205;
      return sum + weightLb * colorL;
    }, 0);
    return totalLbDegL / volumeGal;
  }
  function calculateSRM(input) {
    const mcu = calculateMCU(input);
    if (mcu <= 0) return 0;
    return 1.4922 * Math.pow(mcu, 0.6859);
  }
  function srmToEbc(srm) {
    return srm * 1.97;
  }
  function ebcToSrm(ebc) {
    return ebc / 1.97;
  }

  // src/scaling.ts
  var DEFAULT_GRAIN_ABSORPTION_L_PER_KG = 1.04;
  var DEFAULT_COOLING_SHRINKAGE_PCT = 4;
  function calculateTotalWaterNeeded(equipment) {
    var _a, _b;
    const {
      batchVolumeL,
      boilTimeMin,
      boilOffRateLPerHour,
      trubChillerLossL,
      mashTunDeadspaceL,
      totalGrainWeightKg
    } = equipment;
    if (batchVolumeL <= 0) throw new Error("batchVolumeL turi b\u016Bti teigiamas skai\u010Dius");
    if (boilTimeMin < 0) throw new Error("boilTimeMin negali b\u016Bti neigiamas");
    const grainAbsorptionLPerKg = (_a = equipment.grainAbsorptionLPerKg) != null ? _a : DEFAULT_GRAIN_ABSORPTION_L_PER_KG;
    const coolingShrinkagePct = (_b = equipment.coolingShrinkagePct) != null ? _b : DEFAULT_COOLING_SHRINKAGE_PCT;
    const postBoilVolumeL = batchVolumeL / (1 - coolingShrinkagePct / 100) + trubChillerLossL;
    const boilOffLossL = boilOffRateLPerHour * (boilTimeMin / 60);
    const preBoilVolumeL = postBoilVolumeL + boilOffLossL;
    const grainAbsorptionLossL = totalGrainWeightKg * grainAbsorptionLPerKg;
    const totalWaterNeededL = preBoilVolumeL + grainAbsorptionLossL + mashTunDeadspaceL;
    return { postBoilVolumeL, preBoilVolumeL, totalWaterNeededL };
  }
  function scaleRecipe(fermentables, hops, sourceBatchVolumeL, targetBatchVolumeL) {
    if (sourceBatchVolumeL <= 0 || targetBatchVolumeL <= 0) {
      throw new Error("sourceBatchVolumeL ir targetBatchVolumeL turi b\u016Bti teigiami skai\u010Diai");
    }
    const scaleFactor = targetBatchVolumeL / sourceBatchVolumeL;
    return {
      fermentables: fermentables.map((f) => ({ ...f, weightKg: f.weightKg * scaleFactor })),
      hops: hops.map((h) => ({ ...h, weightG: h.weightG * scaleFactor })),
      scaleFactor
    };
  }

  // src/mash.ts
  var GRAIN_WATER_HEAT_CAPACITY_RATIO = 0.41;
  function calculateStrikeWaterTemp(input) {
    const { targetMashTempC, grainTempC, waterToGrainRatioLPerKg } = input;
    if (waterToGrainRatioLPerKg <= 0) {
      throw new Error("waterToGrainRatioLPerKg turi b\u016Bti teigiamas skai\u010Dius");
    }
    return GRAIN_WATER_HEAT_CAPACITY_RATIO / waterToGrainRatioLPerKg * (targetMashTempC - grainTempC) + targetMashTempC;
  }
  function calculateMashInfusionVolume(input) {
    const { currentMashTempC, targetMashTempC, grainWeightKg, currentMashWaterL, infusionWaterTempC } = input;
    if (infusionWaterTempC <= targetMashTempC) {
      throw new Error(
        "infusionWaterTempC turi b\u016Bti didesn\u0117 u\u017E targetMashTempC (kitaip papildymas ne\u012Fmanomas)"
      );
    }
    const numerator = (targetMashTempC - currentMashTempC) * (GRAIN_WATER_HEAT_CAPACITY_RATIO * grainWeightKg + currentMashWaterL);
    const denominator = infusionWaterTempC - targetMashTempC;
    return numerator / denominator;
  }

  // src/beerxml.ts
  var SUCROSE_REFERENCE_GU = 46;
  function yieldPctToPotentialSg(yieldPct) {
    return 1 + SUCROSE_REFERENCE_GU / 1e3 * (yieldPct / 100);
  }
  function potentialSgToYieldPct(potentialSg) {
    return (potentialSg - 1) * 1e3 / SUCROSE_REFERENCE_GU * 100;
  }
  function decodeXmlEntities(s) {
    return s.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, "&");
  }
  function encodeXmlEntities(s) {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
  }
  function extractElements(xml, tag) {
    const re = new RegExp(`<${tag}\\s*>([\\s\\S]*?)<\\/${tag}\\s*>`, "gi");
    const matches = [];
    let m;
    while ((m = re.exec(xml)) !== null) matches.push(m[1]);
    return matches;
  }
  function extractField(xml, tag) {
    const re = new RegExp(`<${tag}\\s*>([\\s\\S]*?)<\\/${tag}\\s*>`, "i");
    const m = re.exec(xml);
    if (!m) return void 0;
    const text = decodeXmlEntities(m[1]).trim();
    return text.length > 0 && text !== "-" ? text : void 0;
  }
  function extractFieldNumber(xml, tag) {
    const text = extractField(xml, tag);
    if (text === void 0) return void 0;
    const n = Number(text);
    return Number.isFinite(n) ? n : void 0;
  }
  function stripElements(xml, tag) {
    const re = new RegExp(`<${tag}\\s*>[\\s\\S]*?<\\/${tag}\\s*>`, "gi");
    return xml.replace(re, "");
  }
  function parseFermentable(xml) {
    var _a;
    const name = extractField(xml, "NAME");
    const weightKg = (_a = extractFieldNumber(xml, "AMOUNT")) != null ? _a : 0;
    const colorLovibond = extractFieldNumber(xml, "COLOR");
    const potentialFromField = extractFieldNumber(xml, "POTENTIAL");
    const yieldPct = extractFieldNumber(xml, "YIELD");
    const potentialSg = potentialFromField != null ? potentialFromField : yieldPct !== void 0 ? yieldPctToPotentialSg(yieldPct) : 1;
    return { name, weightKg, potentialSg, colorLovibond };
  }
  function parseHop(xml) {
    var _a, _b, _c, _d;
    const name = extractField(xml, "NAME");
    const weightG = ((_a = extractFieldNumber(xml, "AMOUNT")) != null ? _a : 0) * 1e3;
    const alphaAcidPct = (_b = extractFieldNumber(xml, "ALPHA")) != null ? _b : 0;
    const boilTimeMin = (_c = extractFieldNumber(xml, "TIME")) != null ? _c : 0;
    const formRaw = extractField(xml, "FORM");
    const form = formRaw === void 0 ? void 0 : formRaw.toLowerCase().startsWith("pellet") ? "pellet" : "leaf";
    const use = (_d = extractField(xml, "USE")) != null ? _d : "Boil";
    return { hop: { name, weightG, alphaAcidPct, boilTimeMin, form }, use };
  }
  function importBeerXml(xml) {
    var _a, _b, _c, _d, _e, _f, _g;
    const warnings = [];
    const recipeBlocks = extractElements(xml, "RECIPE");
    const recipeXml = recipeBlocks.length > 0 ? recipeBlocks[0] : xml;
    if (recipeBlocks.length > 1) {
      warnings.push(`Faile rasta ${recipeBlocks.length} recept\u0173 \u2014 importuotas tik pirmasis.`);
    }
    const scalarXml = stripElements(stripElements(recipeXml, "FERMENTABLES"), "HOPS");
    const name = (_a = extractField(scalarXml, "NAME")) != null ? _a : "Importuotas receptas";
    const batchVolumeL = (_b = extractFieldNumber(scalarXml, "BATCH_SIZE")) != null ? _b : 0;
    const boilTimeMin = (_c = extractFieldNumber(scalarXml, "BOIL_TIME")) != null ? _c : 60;
    const efficiencyPct = (_d = extractFieldNumber(scalarXml, "EFFICIENCY")) != null ? _d : 72;
    const fermentablesBlock = (_e = extractElements(recipeXml, "FERMENTABLES")[0]) != null ? _e : "";
    const fermentables = extractElements(fermentablesBlock, "FERMENTABLE").map(parseFermentable);
    const hopsBlock = (_f = extractElements(recipeXml, "HOPS")[0]) != null ? _f : "";
    const parsedHops = extractElements(hopsBlock, "HOP").map(parseHop);
    const hops = [];
    for (const { hop, use } of parsedHops) {
      if (use.toLowerCase() === "boil") {
        hops.push(hop);
      } else {
        warnings.push(`Praleistas apynys "${(_g = hop.name) != null ? _g : "?"}" (USE="${use}") \u2014 palaikomi tik "Boil" apyniai.`);
      }
    }
    if (fermentables.length === 0) warnings.push("Recepte nerasta n\u0117 vieno FERMENTABLE \u012Fra\u0161o.");
    if (batchVolumeL <= 0) warnings.push("BATCH_SIZE tr\u016Bksta arba yra 0 \u2014 patikrinkite t\u016Br\u012F rankiniu b\u016Bdu.");
    return { recipe: { name, batchVolumeL, boilTimeMin, efficiencyPct, fermentables, hops }, warnings };
  }
  function exportBeerXml(recipe) {
    const fermentablesXml = recipe.fermentables.map((f) => {
      var _a;
      const yieldPct = potentialSgToYieldPct(f.potentialSg);
      return [
        " <FERMENTABLE>",
        `  <NAME>${encodeXmlEntities((_a = f.name) != null ? _a : "Salyklas")}</NAME>`,
        "  <VERSION>1</VERSION>",
        "  <TYPE>Grain</TYPE>",
        `  <AMOUNT>${f.weightKg}</AMOUNT>`,
        `  <YIELD>${yieldPct.toFixed(1)}</YIELD>`,
        `  <POTENTIAL>${f.potentialSg.toFixed(3)}</POTENTIAL>`,
        ...f.colorLovibond !== void 0 ? [`  <COLOR>${f.colorLovibond}</COLOR>`] : [],
        " </FERMENTABLE>"
      ].join("\n");
    }).join("\n");
    const hopsXml = recipe.hops.map((h) => {
      var _a;
      return [
        " <HOP>",
        `  <NAME>${encodeXmlEntities((_a = h.name) != null ? _a : "Apyniai")}</NAME>`,
        "  <VERSION>1</VERSION>",
        `  <ALPHA>${h.alphaAcidPct}</ALPHA>`,
        `  <AMOUNT>${(h.weightG / 1e3).toFixed(6)}</AMOUNT>`,
        "  <USE>Boil</USE>",
        `  <TIME>${h.boilTimeMin}</TIME>`,
        ...h.form !== void 0 ? [`  <FORM>${h.form === "pellet" ? "Pellet" : "Leaf"}</FORM>`] : [],
        " </HOP>"
      ].join("\n");
    }).join("\n");
    return [
      '<?xml version="1.0" encoding="UTF-8"?>',
      "<RECIPES>",
      "<RECIPE>",
      ` <NAME>${encodeXmlEntities(recipe.name)}</NAME>`,
      " <VERSION>1</VERSION>",
      " <TYPE>All Grain</TYPE>",
      ` <BATCH_SIZE>${recipe.batchVolumeL}</BATCH_SIZE>`,
      ` <BOIL_TIME>${recipe.boilTimeMin}</BOIL_TIME>`,
      ` <EFFICIENCY>${recipe.efficiencyPct}</EFFICIENCY>`,
      " <FERMENTABLES>",
      fermentablesXml,
      " </FERMENTABLES>",
      " <HOPS>",
      hopsXml,
      " </HOPS>",
      "</RECIPE>",
      "</RECIPES>"
    ].join("\n");
  }

  // src/index.ts
  function calculateIbu(input, method = "tinseth") {
    return method === "rager" ? calculateIbuRager(input) : calculateIbuTinseth(input);
  }
  return __toCommonJS(index_exports);
})();
